import { createAction } from '@reduxjs/toolkit';
import { RESET_VALIDATION_FIELDS, SET_VALIDATION_CONFIG, VALIDATE_FIELD, VALIDATE_FORM, SET_FIELD_ERRORS, } from './actionsTypes';
export const validateForm = createAction(VALIDATE_FORM);
export const validateField = createAction(VALIDATE_FIELD);
export const setValidateConfig = createAction(SET_VALIDATION_CONFIG);
export const resetValidationFields = createAction(RESET_VALIDATION_FIELDS);
export const setFieldErrors = createAction(SET_FIELD_ERRORS);
